import React, { useEffect, useState } from "react";
import MobileTrading from "../mobile/MobileTrading";
import {
  Navbar,
  Footer,
  FloatingActions,
  ContactForm,
  SocialRow,
} from "../components/Shared";

const brands = [
  "Vertiv",
  "Hubbell",
  "RACO",
  "Burndy",
  "Corning",
  "Appleton",
  "Calmint",
  "Honeywell",
  "Eaton",
  "Pizzato",
  "ABB",
  "Siemens",
  "Legrand",
  "APC",
  "Schneider",
  "Belden",
  "Omron",
  "Moxa"
];

const categories = [
  {
    icon: "fa-microchip",
    title: "Industrial Electrical & Electronic Components",
    items: [
      "Relays & Sensors",
      "PLC Components",
      "Industrial Controllers",
      "Automation Accessories",
      "Electronic Components"
    ]
  },
  {
    icon: "fa-plug",
    title: "Electrical & Network Products",
    items: [
      "Plugs & Connectors",
      "Switches & Receptacles",
      "Patch Panels",
      "CAT6 UTP Cable",
      "RJ45 Keystone Jacks"
    ]
  },
  {
    icon: "fa-lightbulb",
    title: "Lighting & Signaling",
    items: [
      "Signal Lights",
      "Warning Systems",
      "Industrial Indicators",
      "Motor Sirens",
      "Emergency Lighting"
    ]
  },
  {
    icon: "fa-network-wired",
    title: "Telecom & Connectivity",
    items: [
      "Structured Cabling",
      "LMR-400 Cables",
      "TNC Connectors",
      "Connectivity Systems",
      "Network Accessories"
    ]
  },
  {
    icon: "fa-battery-full",
    title: "Power Solutions",
    items: [
      "UPS Systems",
      "Rack PDUs",
      "Power Backup",
      "Monitoring Systems",
      "Power Infrastructure"
    ]
  },
  {
    icon: "fa-industry",
    title: "Industrial Supply",
    items: [
      "Global Brand Supply",
      "Fast Procurement",
      "Project Support",
      "Industrial Accessories",
      "Infrastructure Materials"
    ]
  }
];

export default function Trading() {
  

const [isMobile, setIsMobile] = useState(false);
const [openCard, setOpenCard] = useState(null);

useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.matchMedia("(max-width: 768px)").matches);
  };

  checkMobile();

  window.addEventListener("resize", checkMobile);

  return () => window.removeEventListener("resize", checkMobile);
}, []);

if (isMobile) {
  return <MobileTrading />;
}
   return (
    
    <div className="min-h-screen bg-white overflow-hidden text-slate-800">

      {/* NAVBAR */}
      <div className="fixed top-0 left-0 w-full z-[100] backdrop-blur-xl">
        <Navbar
          showProducts={true}
          showVertiv={true}
        />
      </div>

      {/* HERO */}
      <section
        id="home"
        className="relative overflow-hidden min-h-screen bg-cover bg-center pt-20"
        style={{
          backgroundImage: "url('/trading-aboutus.png')",
        }}
      >

        {/* CLEAN PROFESSIONAL OVERLAY */}
        <div className="absolute inset-0 bg-white/72" />

        {/* LIGHT BLUE EFFECT */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 to-blue-100/40" />

        {/* SMALL GLOW */}
        <div className="absolute top-[-120px] right-[-100px] w-[400px] h-[400px] bg-cyan-300/20 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-[1450px] mx-auto px-6 lg:px-10 py-12 lg:py-20">

          <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* LEFT CONTENT */}
            <div className="max-w-2xl">

              

              {/* REMOVE EXTRA LOGO / BADGE */}

              {/* SMALL TAG */}
              <div className="mt-8 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-white border border-blue-100 shadow-md">

                <div className="w-9 h-9 rounded-full bg-gradient-to-r from-blue-700 to-cyan-500 text-white grid place-items-center">
                  <i className="fas fa-bolt text-sm" />
                </div>

                <span className="text-sm font-semibold text-blue-800 tracking-wide">
                  Industrial Trading & Supply • UAE
                </span>
              </div>

              {/* HEADING */}
              <h1 className="mt-8 text-[42px] sm:text-[52px] md:text-[66px] lg:text-[78px] font-black leading-[1] tracking-[-3px] text-slate-900">

                Powering

                <span className="block bg-gradient-to-r from-blue-700 via-cyan-500 to-blue-500 bg-clip-text text-transparent">
                  Industrial Growth
                </span>

                <span className="block text-slate-800">
                  With Trusted Brands
                </span>
              </h1>

              {/* DESCRIPTION */}
              <p className="mt-7 text-[16px] md:text-[18px] text-slate-600 leading-[1.9] max-w-2xl">
                BAJABAR INCORPORATION FZE delivers world-class
                electrical, telecom, lighting, automation and
                industrial power solutions from globally trusted brands
                for infrastructure and commercial projects.
              </p>

              {/* BUTTONS */}
              <div className="mt-10 flex flex-wrap gap-5">

                <a
                  href="#contact"
                  className="group relative overflow-hidden px-7 py-4 rounded-2xl bg-gradient-to-r from-blue-700 to-cyan-500 text-white font-bold shadow-[0_15px_40px_rgba(37,99,235,0.35)] hover:scale-105 transition-all duration-500"
                >

                  <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-all duration-500" />

                  <span className="relative z-10 flex items-center gap-2">
                    <i className="fas fa-paper-plane" />
                    Send Inquiry
                  </span>
                </a>

                <a
                  href="#products"
                  className="px-7 py-4 rounded-2xl border border-blue-200 bg-white text-blue-700 font-bold hover:bg-blue-50 hover:scale-105 transition-all duration-500 shadow-lg"
                >
                  <i className="fas fa-boxes mr-2" />
                  Explore Products
                </a>

              </div>

              {/* FEATURES */}
              <div className="mt-10 flex flex-wrap gap-6">

                {[
                  ["fa-award", "Authorized Supplier"],
                  ["fa-globe", "Worldwide Distribution"],
                  ["fa-shield-alt", "Trusted Quality"],
                ].map(([icon, text]) => (

                  <div
                    key={text}
                    className="flex items-center gap-3"
                  >

                    <div className="w-10 h-10 rounded-xl bg-blue-100 text-blue-700 grid place-items-center">
                      <i className={`fas ${icon}`} />
                    </div>

                    <span className="font-semibold text-slate-700 text-sm">
                      {text}
                    </span>
                  </div>
                ))}
              </div>

              {/* STATS */}
              <div className="mt-14 grid grid-cols-3 gap-6 max-w-xl">

                {[
                  ["100+", "Global Brands"],
                  ["500+", "Industrial Products"],
                  ["24/7", "Support Service"],
                ].map(([num, label]) => (

                  <div
                    key={label}
                    className="bg-white border border-blue-100 rounded-3xl px-5 py-6 shadow-xl"
                  >

                    <div className="text-4xl md:text-5xl font-black bg-gradient-to-r from-blue-700 to-cyan-500 bg-clip-text text-transparent">
                      {num}
                    </div>

                    <div className="mt-3 uppercase tracking-[0.22em] text-[11px] font-bold text-slate-500">
                      {label}
                    </div>

                  </div>
                ))}
              </div>

            </div>

            {/* RIGHT SIDE */}
            <div className="grid grid-cols-2 gap-6">

              {[
                {
                  i: "fa-microchip",
                  t: "Automation",
                  d: "Industrial Controllers & PLC"
                },
                {
                  i: "fa-plug",
                  t: "Electrical",
                  d: "Plugs, Switches & Connectors"
                },
                {
                  i: "fa-lightbulb",
                  t: "Lighting",
                  d: "Industrial Signaling Systems"
                },
                {
                  i: "fa-network-wired",
                  t: "Telecom",
                  d: "Connectivity & Cabling"
                },
                {
                  i: "fa-battery-full",
                  t: "Power",
                  d: "UPS & Rack Solutions"
                },
                {
                  i: "fa-industry",
                  t: "Supply",
                  d: "Global Industrial Procurement"
                }
              ].map((c) => (

                <div
                  key={c.t}
                  className="group bg-white/90 backdrop-blur-xl border border-blue-100 rounded-[30px] p-6 shadow-[0_15px_40px_rgba(0,0,0,0.08)] hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(37,99,235,0.18)] transition-all duration-500"
                >

                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-700 to-cyan-500 text-white grid place-items-center text-xl shadow-lg group-hover:scale-110 transition-all duration-500">
                    <i className={`fas ${c.i}`} />
                  </div>

                  <h3 className="mt-5 text-xl font-bold text-slate-900">
                    {c.t}
                  </h3>

                  <p className="mt-3 text-slate-600 leading-relaxed text-sm">
                    {c.d}
                  </p>

                </div>
              ))}
            </div>

          </div>

        </div>

        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent" />

      </section>

      {/* ABOUT */}
      <section
        id="about"
        className="max-w-[1450px] mx-auto px-6 lg:px-10 py-24"
      >

        <div className="text-center">

          <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-blue-50 border border-blue-100 text-blue-700 font-bold uppercase tracking-[0.18em] text-xs">
            About Us
          </span>

          <h2 className="mt-7 text-[38px] md:text-[56px] lg:text-[68px] font-black leading-[1.05] tracking-[-3px] text-slate-900">

            Reliable Industrial

            <span className="block bg-gradient-to-r from-blue-700 to-cyan-500 bg-clip-text text-transparent">
              Trading Solutions
            </span>
          </h2>

        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mt-20">

          {/* LEFT */}
          <div>

            <p className="text-slate-600 text-lg leading-[2]">
              BAJABAR INCORPORATION FZE is a leading supplier of
              electrical, industrial, telecom and lighting solutions
              serving infrastructure and commercial sectors.
            </p>

            <p className="mt-6 text-slate-600 text-lg leading-[2]">
              We provide reliable procurement, fast delivery,
              competitive pricing and high-quality materials
              sourced from globally trusted manufacturers.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">

              {[
                "Industrial Electrical Supply",
                "Telecom & Connectivity",
                "Global Vendor Network",
                "Fast Procurement"
              ].map((item) => (

                <div
                  key={item}
                  className="flex items-center gap-4 bg-white rounded-3xl border border-blue-100 p-5 shadow-lg"
                >

                  <div className="w-12 h-12 rounded-2xl bg-blue-100 text-blue-700 grid place-items-center">
                    <i className="fas fa-check" />
                  </div>

                  <div className="font-semibold text-slate-700">
                    {item}
                  </div>

                </div>
              ))}

            </div>

          </div>

          {/* IMAGE */}
          <div className="relative">

            <div className="rounded-[40px] overflow-hidden border border-blue-100 shadow-[0_25px_60px_rgba(0,0,0,0.12)]">

              <img
                src="/trading-aboutus.png"
                alt="Industrial"
                className="w-full h-[550px] object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#08142b]/55 via-transparent to-transparent" />

            </div>

          </div>

        </div>

      </section>

      {/* BRANDS */}
      <section
        id="brands"
        className="py-20 bg-blue-50/60"
      >

        <div className="max-w-[1450px] mx-auto px-6 lg:px-10">

          <div className="text-center">

            <span className="bj-eyebrow">
              Trusted Global Partners
            </span>

            <h2 className="mt-4 text-[36px] md:text-[52px] font-black text-blue-950">
              Brands We Supply
            </h2>

          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-5">

            {brands.map((b) => (

              <div
                key={b}
                className="bg-white rounded-2xl border border-blue-100 py-5 text-center font-bold text-blue-800 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                {b}
              </div>

            ))}

          </div>

        </div>

      </section>

      {/* PRODUCTS */}
      <section
        id="products"
        className="max-w-[1450px] mx-auto px-6 lg:px-10 py-24"
      >

        <div className="text-center">

          <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-blue-50 border border-blue-100 text-blue-700 font-bold uppercase tracking-[0.18em] text-xs">
            Product Categories
          </span>

          <h2 className="mt-7 text-[38px] md:text-[56px] lg:text-[68px] font-black leading-[1.05] tracking-[-3px] text-slate-900">

            Complete Industrial

            <span className="block bg-gradient-to-r from-blue-700 to-cyan-500 bg-clip-text text-transparent">
              Product Solutions
            </span>

          </h2>

        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-7">

          {categories.map((c) => (

            <div
              key={c.title}
              className="group bg-white border border-blue-100 rounded-[34px] p-7 shadow-[0_15px_40px_rgba(0,0,0,0.06)] hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(37,99,235,0.16)] transition-all duration-500"
            >

              <div className="w-16 h-16 rounded-3xl bg-gradient-to-br from-blue-700 to-cyan-500 text-white grid place-items-center text-2xl shadow-xl">
                <i className={`fas ${c.icon}`} />
              </div>

              <h3 className="mt-6 text-2xl font-bold text-slate-900 leading-snug">
                {c.title}
              </h3>

              <div className="w-16 h-1 rounded-full bg-gradient-to-r from-blue-700 to-cyan-500 mt-5" />

              <ul className="mt-7 space-y-4">

                {c.items.map((it) => (

                  <li
                    key={it}
                    className="flex items-start gap-4 text-slate-600 leading-relaxed"
                  >

                    <div className="w-6 h-6 rounded-full bg-blue-100 text-blue-700 grid place-items-center text-[10px] mt-1">
                      <i className="fas fa-check" />
                    </div>

                    <span>{it}</span>

                  </li>

                ))}

              </ul>

            </div>

          ))}

        </div>

      </section>
      {/* VERTIV */}
{/* VERTIV */}
<section
  className="bg-gradient-to-b from-blue-50/70 to-white py-20 lg:py-24"
  id="vertiv"
>
  <div className="max-w-[1450px] mx-auto px-6 lg:px-10">

    {/* HEADER */}
    <div className="text-center max-w-4xl mx-auto">

      <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-blue-50 border border-blue-100 text-blue-700 font-bold uppercase tracking-[0.18em] text-xs">
        Vertiv Solutions
      </span>

      <h2 className="mt-7 text-[38px] md:text-[56px] lg:text-[68px] font-black leading-[1.05] tracking-[-3px] text-slate-900">

        Vertiv Silver

        <span className="block bg-gradient-to-r from-blue-700 to-cyan-500 bg-clip-text text-transparent">
          Solution Provider
        </span>

      </h2>

      <p className="mt-7 text-slate-600 text-lg leading-[1.9] max-w-3xl mx-auto">
        Critical infrastructure solutions for data centers,
        communication networks and industrial environments.
        BAJABAR INCORPORATION FZE supplies reliable Vertiv
        power, rack and monitoring solutions for mission-critical operations.
      </p>

    </div>

    {/* GRID */}
    <div className="grid lg:grid-cols-3 gap-6">

  {[
    {
      icon: "fa-battery-full",
      title: "UPS Solutions",
      desc: "Reliable backup power infrastructure for mission critical environments.",
      features: [
        "Data Centers",
        "Server Rooms",
        "Remote Monitoring",
        "Energy Efficient"
      ],
      more: {
        applications: [
          "Industrial Facilities",
          "Emergency Lighting",
          "Communication Networks"
        ],
        capacity: "0.35 kVA to 500 kVA",
        compliance: [
          "Energy Star",
          "CE Certified",
          "TAA Compliant"
        ],
        monitoring: [
          "Communication Cards",
          "Battery Monitoring",
          "Remote Access"
        ]
      }
    },

    {
      icon: "fa-server",
      title: "Racks & Containment",
      desc: "Structured rack infrastructure and airflow optimization systems.",
      features: [
        "Server Cabinets",
        "Cable Management",
        "Cooling Efficiency",
        "Scalable Deployment"
      ],
      more: {
        products: [
          "Wall Mount Racks",
          "Open Frame Racks",
          "Industrial Rack Systems"
        ],
        sizes: "18U, 24U, 42U & Custom Sizes",
        deployment: [
          "Structured Cabling",
          "Data Center Ready",
          "Heavy Duty Capacity"
        ]
      }
    },

    {
      icon: "fa-plug",
      title: "Rack PDUs",
      desc: "Intelligent rack power monitoring and energy management systems.",
      features: [
        "Smart PDUs",
        "Remote Access",
        "Power Analytics",
        "Monitoring Systems"
      ],
      more: {
        pdus: [
          "Basic Rack PDUs",
          "Metered PDUs",
          "Switched PDUs"
        ],
        solutions: [
          "Environmental Sensors",
          "Cable Management",
          "Monitoring Software"
        ]
      }
    }
  ].map((v, index) => (

    <div
      key={v.title}
      className="bg-white rounded-[30px] border border-blue-100 overflow-hidden shadow-[0_15px_45px_rgba(0,0,0,0.07)] hover:-translate-y-1 transition-all duration-500"
    >

      {/* TOP */}
      <div className="bg-gradient-to-r from-blue-700 to-cyan-500 text-white p-6">

        <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-2xl bg-white/15 grid place-items-center text-xl lg:text-2xl">
          <i className={`fas ${v.icon}`} />
        </div>

        <h3 className="font-display text-xl lg:text-2xl font-bold mt-5">
          {v.title}
        </h3>

        <p className="text-blue-100 text-[13px] md:text-sm mt-3 leading-relaxed">
          {v.desc}
        </p>

      </div>

      {/* CONTENT */}
      <div className="p-6">

        {/* MAIN FEATURES */}
        <ul className="space-y-3">

          {v.features.map((item) => (

            <li
              key={item}
              className="flex items-center gap-3 text-slate-600 text-[13px] md:text-sm"
            >
              <div className="w-6 h-6 rounded-full bg-blue-100 text-blue-700 grid place-items-center text-[10px]">
                <i className="fas fa-check" />
              </div>

              {item}
            </li>
          ))}

        </ul>

        {/* READ MORE TEXT */}
        <div className="mt-6 text-sm text-slate-500 leading-relaxed">
          Explore additional technical specifications,
          monitoring capabilities and infrastructure solutions.
        </div>

        {/* BUTTON */}
        <button
          onClick={() =>
            setOpenCard(openCard === index ? null : index)
          }
          className="mt-6 inline-flex items-center gap-2 text-blue-700 font-bold hover:text-cyan-600 transition"
        >

          {openCard === index ? "Show Less" : "Read More"}

          <i
            className={`fas ${
              openCard === index
                ? "fa-chevron-up"
                : "fa-chevron-down"
            }`}
          />

        </button>

        {/* EXPANDED CONTENT */}
        <div
          className={`transition-all duration-500 overflow-hidden ${
            openCard === index
              ? "max-h-[600px] opacity-100 mt-7"
              : "max-h-0 opacity-0"
          }`}
        >

          <div className="border-t border-blue-100 pt-6 space-y-6">

            {v.more.capacity && (
              <div>
                <h4 className="font-bold text-blue-800 text-sm uppercase tracking-[0.15em]">
                  Capacity Range
                </h4>

                <p className="mt-3 text-slate-600 text-sm">
                  {v.more.capacity}
                </p>
              </div>
            )}

            {v.more.sizes && (
              <div>
                <h4 className="font-bold text-blue-800 text-sm uppercase tracking-[0.15em]">
                  Rack Sizes
                </h4>

                <p className="mt-3 text-slate-600 text-sm">
                  {v.more.sizes}
                </p>
              </div>
            )}

            {Object.entries(v.more).map(([key, value]) => {

              if (typeof value === "string") return null;

              return (
                <div key={key}>

                  <h4 className="font-bold text-blue-800 text-sm uppercase tracking-[0.15em]">
                    {key}
                  </h4>

                  <ul className="mt-3 space-y-2">

                    {value.map((x) => (

                      <li
                        key={x}
                        className="flex items-start gap-3 text-slate-600 text-sm"
                      >

                        <div className="w-5 h-5 rounded-full bg-blue-100 text-blue-700 grid place-items-center text-[9px] mt-[2px]">
                          <i className="fas fa-check" />
                        </div>

                        {x}

                      </li>
                    ))}

                  </ul>

                </div>
              );
            })}

          </div>

        </div>

      </div>

    </div>
  ))}

</div>
    {/* AUTHORIZED BRANDS */}
    <div className="mt-16">

      <div className="bg-gradient-to-r from-blue-700 via-blue-800 to-cyan-600 rounded-[36px] px-8 py-10 text-center text-white shadow-[0_25px_70px_rgba(0,0,0,0.12)]">

        <div className="w-16 h-16 mx-auto rounded-3xl bg-white/15 backdrop-blur-xl grid place-items-center text-2xl">
          <i className="fas fa-award" />
        </div>

        <h3 className="mt-6 text-3xl md:text-4xl font-black">
          Authorized Supply Network
        </h3>

        <p className="mt-5 text-blue-100 max-w-3xl mx-auto leading-[1.9]">
          BAJABAR INCORPORATION FZE supplies infrastructure
          solutions and industrial products from globally trusted
          manufacturers including Vertiv, Hubbell, RACO,
          Schneider Electric, APC, Eaton and other leading brands.
        </p>

        {/* BRANDS */}
        <div className="mt-10 flex flex-wrap justify-center gap-4">

          {[
            "Vertiv",
            "Hubbell",
            "RACO",
            "Schneider",
            "APC",
            "Eaton",
            "ABB",
            "Siemens"
          ].map((brand) => (

            <div
              key={brand}
              className="px-5 py-3 rounded-2xl bg-white/10 border border-white/10 backdrop-blur-xl text-sm font-bold tracking-wide"
            >
              {brand}
            </div>

          ))}

        </div>

      </div>

    </div>

  </div>
</section>
{/* WHY US */}
<section
  id="why"
  className="relative py-24 overflow-hidden bg-gradient-to-b from-white to-blue-50"
>

  {/* GLOW EFFECTS */}
  <div className="absolute top-[-150px] left-[-120px] w-[420px] h-[420px] bg-blue-200/20 rounded-full blur-[120px]" />

  <div className="absolute bottom-[-150px] right-[-120px] w-[420px] h-[420px] bg-cyan-200/20 rounded-full blur-[120px]" />

  <div className="relative z-10 max-w-[1450px] mx-auto px-6 lg:px-10">

    {/* HEADING */}
    <div className="text-center max-w-4xl mx-auto">

      <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-blue-50 border border-blue-100 text-blue-700 font-bold uppercase tracking-[0.18em] text-xs">
        Why Choose Bajabar
      </span>

      <h2 className="mt-7 text-[38px] md:text-[56px] lg:text-[68px] font-black leading-[1.05] tracking-[-3px] text-slate-900">

        Trusted Industrial

        <span className="block bg-gradient-to-r from-blue-700 to-cyan-500 bg-clip-text text-transparent">
          Supply Partner
        </span>

      </h2>

      <p className="mt-7 text-slate-600 text-lg leading-[1.9] max-w-3xl mx-auto">
        Delivering reliable industrial procurement,
        electrical infrastructure products and telecom
        solutions with global sourcing expertise,
        competitive pricing and fast delivery support.
      </p>

    </div>

    {/* FEATURES GRID */}
    <div className="mt-20 grid md:grid-cols-2 lg:grid-cols-4 gap-7">

      {[
        {
          icon: "fa-globe",
          title: "Global Sourcing",
          desc: "Strong international supplier network with access to premium industrial brands worldwide."
        },
        {
          icon: "fa-shipping-fast",
          title: "Fast Delivery",
          desc: "Efficient procurement and logistics support ensuring timely project execution."
        },
        {
          icon: "fa-award",
          title: "Premium Quality",
          desc: "Supplying reliable products from globally trusted electrical and automation manufacturers."
        },
        {
          icon: "fa-headset",
          title: "Dedicated Support",
          desc: "Professional technical assistance and customer support for industrial requirements."
        }
      ].map((item) => (

        <div
          key={item.title}
          className="group bg-white rounded-[32px] border border-blue-100 p-8 shadow-[0_15px_45px_rgba(0,0,0,0.06)] hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(37,99,235,0.15)] transition-all duration-500"
        >

          {/* ICON */}
          <div className="w-16 h-16 rounded-3xl bg-gradient-to-br from-blue-700 to-cyan-500 text-white grid place-items-center text-2xl shadow-xl group-hover:scale-110 transition duration-500">
            <i className={`fas ${item.icon}`} />
          </div>

          {/* TITLE */}
          <h3 className="mt-7 text-2xl font-bold text-slate-900">
            {item.title}
          </h3>

          {/* LINE */}
          <div className="w-14 h-1 rounded-full bg-gradient-to-r from-blue-700 to-cyan-500 mt-5" />

          {/* DESC */}
          <p className="mt-6 text-slate-600 leading-[1.9] text-[15px]">
            {item.desc}
          </p>

        </div>
      ))}

    </div>

    {/* BOTTOM STATS */}
    <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">

      {[
        ["15+", "Years Industry Experience"],
        ["100+", "Global Supply Brands"],
        ["500+", "Completed Deliveries"],
        ["24/7", "Customer Assistance"]
      ].map(([num, label]) => (

        <div
          key={label}
          className="bg-white rounded-[30px] border border-blue-100 p-7 text-center shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-500"
        >

          <div className="text-5xl font-black bg-gradient-to-r from-blue-700 to-cyan-500 bg-clip-text text-transparent">
            {num}
          </div>

          <div className="mt-4 text-[12px] uppercase tracking-[0.22em] font-bold text-slate-500">
            {label}
          </div>

        </div>
      ))}

    </div>

  </div>

</section>
      {/* CONTACT */}
      <section
  id="contact"
  className="scroll-mt-28 bg-gradient-to-b from-white to-blue-50 py-24"
>

        <div className="max-w-[1450px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14">

          {/* LEFT */}
          <div>

            <span className="bj-eyebrow">
              Contact Us
            </span>

            <h2 className="mt-4 text-[38px] md:text-[56px] font-black text-blue-950">
              Send Your Inquiry
            </h2>

            <p className="mt-6 text-slate-600 text-lg leading-[1.9] max-w-lg">
              Reach out to our team for industrial supply,
              telecom, electrical and power infrastructure requirements.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">

              <div className="bg-white rounded-3xl border border-blue-100 p-6 shadow-lg">

                <div className="font-bold text-blue-950 text-lg">
                  <i className="fas fa-user-tie text-blue-600 mr-2" />
                  Zubair Bin Mohammed
                </div>

                <div className="text-slate-500 mt-1">
                  Managing Director
                </div>

                <div className="mt-4 text-slate-700 leading-7">
                  zubair@bajabarinc.ae
                  <br />
                  +971 525131571
                </div>

              </div>

              <div className="bg-white rounded-3xl border border-blue-100 p-6 shadow-lg">

                <div className="font-bold text-blue-950 text-lg">
                  <i className="fas fa-user-tie text-blue-600 mr-2" />
                  Mohammed A. Mannan
                </div>

                <div className="text-slate-500 mt-1">
                  Business Development
                </div>

                <div className="mt-4 text-slate-700 leading-7">
                  mohammed@bajabarinc.ae
                  <br />
                  +91 81252 11886
                </div>

              </div>

            </div>

            <div className="mt-10">
              <SocialRow />
            </div>

          </div>

          {/* FORM */}
          <div className="bg-white rounded-[40px] border border-blue-100 shadow-[0_25px_60px_rgba(0,0,0,0.08)] p-8 md:p-10">

            <h3 className="text-3xl font-black text-blue-950">
              Get In Touch
            </h3>

            <p className="mt-3 text-slate-600">
              Fill the form and our team will contact you shortly.
            </p>

            <div className="mt-8">

              <ContactForm
                division="trading"
                services={[
                  "Electrical",
                  "Lighting",
                  "Telecom",
                  "Power",
                  "Vertiv Solutions",
                  "Other"
                ]}
              />

            </div>

          </div>

        </div>

      </section>

      <Footer />
      <FloatingActions />

    </div>
  );
}